import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import RequestTalkMobile from "../../components/common/mobile/RequestTalkMobile";
import { Helmet } from "react-helmet";
import { httpReauest } from "../../utils/httpRequest";
import { useRouteInfo } from "../../hooks/useRouteInfo";

const ContactUsPageMobile = () => {
  const [data, setData] = useState();
  const { metaData } = useRouteInfo();

  useEffect(() => {
    getData();
  }, []);

  async function getData(params) {
    await httpReauest("GET", `/data`, {}, {}).then(({ data }) => {
      setData(data?.data[0]);
    });
  }

  return (
    <div className="pb-7">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <Link to={"/"} className="flex gap-2 items-center text-[14px]">
        <img src="/Arrow - Left 2.png" alt="" className="w-[24px]" />
        بازگشت به صفحه اصلی
      </Link>
      <h1 className="text-center title-mobile py-3">{metaData?.h1}</h1>
      <RequestTalkMobile />
      <div className="grid grid-cols-4 gap-2 text-[14px] sm:text-[16px] py-9 font-bold">
        <Link
          to={`tel:${data?.phone}`}
          className="col-span-2 flex flex-col justify-center items-center gap-3 p-5 bg-[#F8FAFA] rounded-[8px]"
        >
          <img src="/Call.png" alt="Call" className="w-[25px]" />
          {data?.phone}
        </Link>
        <Link
          href={data?.aparat}
          target="_blank"
          rel="noreferrer"
          className="col-span-2 flex flex-col justify-center items-center gap-3 p-5 bg-[#F8FAFA] rounded-[8px]"
        >
          <img src="/aparat.svg" alt="Aparat" className="w-[25px]" />
          1924aparat
        </Link>
        <Link
          to={data?.instagram}
          className="col-span-2 flex flex-col justify-center items-center gap-3 p-5 bg-[#F8FAFA] rounded-[8px]"
        >
          <img src="/mdi_instagram.png" alt="Call" className="w-[25px]" />
          1924instagram
        </Link>
        <Link
          to={data?.telegram}
          className="col-span-2 flex flex-col justify-center items-center gap-3 p-5 bg-[#F8FAFA] rounded-[8px]"
        >
          <img src="/la_telegram.png" alt="Call" className="w-[25px]" />
          1924-Support
        </Link>
        <Link
          to={data?.whatsapp}
          className="col-span-2 col-start-2 flex flex-col justify-center items-center gap-3 p-5 bg-[#F8FAFA] rounded-[8px]"
        >
          <img src="/whatsapp.png" alt="Call" className="w-[25px]" />
          1924-whatsapp
        </Link>
        <Link
          to={`mail:${data?.email}`}
          className="col-span-full flex  justify-start items-center gap-3 p-3 bg-[#F8FAFA] rounded-[8px]"
        >
          <img src="/Message.png" alt="Call" className="w-[25px]" />
          1924contactus@gmail.com
        </Link>
        <Link
          to={`tel:${data?.phone}`}
          className="col-span-full flex flex-wrap justify-center items-start gap-3 p-3 bg-[#F8FAFA] rounded-[8px]"
        >
          <span className="flex items-start gap-3">
            <img src="/Location.png" alt="Call" className="w-[25px]" />

            <p className="mb-4">
              مشهد ابتدای جاده قدیم نیشابور رباط طرق ساختمان ۱۹۲۴
            </p>
          </span>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=36.194368,59.620695"
            target="_blank"
            rel="noreferrer"
            className="btn-brand-mobile w-[70%]"
          >
            مسیریابی
          </a>
        </Link>
        <iframe
          title="location"
          className="rounded-[8px] col-span-full w-full h-[250px] border-brand"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3219.4323099585054!2d59.62227684503667!3d36.204685875022335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzbCsDEyJzE3LjgiTiA1OcKwMzcnMjQuNiJF!5e0!3m2!1sen!2sus!4v1751460661468!5m2!1sen!2sus"
        />
      </div>
    </div>
  );
};

export default ContactUsPageMobile;
